@if (fallbackSrc && thumbnailSrc) {
  @if (isLazyLoad) {
    <picture>
      @for (source of srcSet; track source.src) {
        <source
          [attr.lazyLoad]="source.src"
          media="(min-width: {{ source.width }}px)"
          [attr.defaultImage]="thumbnailSrc"
        />
      }
      <img
        [attr.fetchpriority]="fetchPriority"
        [attr.alt]="alt || ''"
        [class]="hasAspectRatio ? 'ratio-' + ratio : ''"
        [attr.src]="thumbnailSrc"
        [lazyLoad]="fallbackSrc"
        [ngClass]="{ fill: true, 'fill-parent': fillParent, scale: scale }"
        [style.aspect-ratio]="customAspectRatio"
      />
    </picture>
  } @else {
    <img
      [attr.srcset]="isDefaultImageLoaded() ? preloadImages : null"
      [attr.sizes]="isDefaultImageLoaded() ? preloadImagesWidth : null"
      [attr.src]="thumbnailSrc"
      [attr.alt]="alt || ''"
      [attr.fetchpriority]="fetchPriority"
      [ngClass]="{
        fill: true,
        'fill-parent': fillParent,
        scale: scale,
        blur: isDefaultImageLoaded() === false,
      }"
      [style.aspect-ratio]="customAspectRatio"
      [class]="hasAspectRatio ? 'ratio-' + ratio : ''"
      (load)="onImageLoaded()"
      loading="eager"
    />
  }
}
